export const COMPANY_LEGAL_INFO = {
  name: 'ScaleNix',
  legalForm: 'SASU, société par actions simplifiée unipersonnelle',
  registrationDate: '26/07/2024',
  registrationNumber: '933 609 232',
  siret: '933 609 232 00014',
  siren: '933 609 232',
  rcs: 'Lyon',
  rcsDetails: '933 609 232 R.C.S. Lyon',
  vatNumber: 'FR44933609232',
  shareCapital: '2 000,00 €',
  address: {
    street: '27 Rue Anatoile Celle',
    city: 'Chaponost',
    postalCode: '69630',
    country: 'France'
  },
  activity: 'Conseil en systèmes et logiciels informatiques',
  activityCode: '6202A',
  legalRepresentative: 'M. BENMEKKI MALIK',
  position: 'Président',
  registrations: {
    rcs: {
      status: 'INSCRIT',
      location: 'au greffe de LYON',
      date: '03/10/2024'
    },
    rne: 'INSCRIT'
  }
};